import { render, staticRenderFns } from "./GoalsTab.vue?vue&type=template&id=4a7af588&scoped=true"
import script from "./GoalsTab.vue?vue&type=script&lang=js"
export * from "./GoalsTab.vue?vue&type=script&lang=js"
import style0 from "./GoalsTab.vue?vue&type=style&index=0&id=4a7af588&prod&lang=scss"
import style1 from "./GoalsTab.vue?vue&type=style&index=1&id=4a7af588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7af588",
  null
  
)

export default component.exports